(function($) {

	'use strict';

	var init = function() {

        if($('.page-template-template-application-tunnel').length > 0) {
            
            manageTunnel();

        }   

    };
    
    var manageTunnel = function() {

        $('select').each(function() {
            if($(this).val() != '') {
                $(this).addClass('medium');
            }

            $(this).on('focus', function() {
                $(this).addClass('medium');
            });
            $(this).on('blur', function() {
                if($(this).val() == '') {
                    $(this).removeClass('medium');
                }
            });
        });
    }

	$(document).ready(function() {
		init();
    });
    $(document).on('gform_post_render', function() {
        init();
    });

})(jQuery);